import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule }         from '@angular/common';
import { FormsModule }   from '@angular/forms';

import { LoginComponent}      from './login.component';
import { PasswordRequestComponent}      from './request-password.component';

/*Layout*/
import { MatProgressSpinnerModule } from '@angular/material';

@NgModule({
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    FormsModule,
    RouterModule.forChild([
    	{path: 'login', component: LoginComponent},
      {path: 'password', component: PasswordRequestComponent},
    ])
  ],
	declarations: [
		LoginComponent, 
		PasswordRequestComponent
	]
})
export class AuthModule {}

